<page-heading
  [title]="'chatbot.home.pageTitle' | translate"
  [description]="'chatbot.home.pageDescription' | translate"
  />

@if (channel) {
  <form [formGroup]="formGroup">
    <div class="card">
      <div class="card-body">
        <div class="custom-switch mb-3">
          <input
            type="checkbox"
            id="actived"
            data-switch="success"
            formControlName="actived"
            tabindex="0"
            />
          <label for="actived">
            <span class="d-block fw-bold">
              {{
              (formGroup.get("actived").value
              ? "chatbot.home.chatbotEnabled"
              : "chatbot.home.chatbotDisabled") | translate
              }}
            </span>
          </label>
        </div>

        <div class="row gx-4">
          <div class="col-md-8">
            <div class="chatbot-message-container h-100">
              <h5 class="mb-1">{{ 'chatbot.home.welcomeMessage' | translate }}</h5>
              <div class="form-floating mb-2 position-relative h-100">
                <textarea
                  formControlName="message"
                  class="form-control"
                  [placeholder]="'chatbot.home.typePlaceholder' | translate"
                  rows="8"
                  (paste)="onPaste($event)"
                  #messageTextarea
                ></textarea>
                <field-error-component
                  [field]="'message'"
                  [label]="'chatbot.home.messageLabel' | translate"
                  [formGroup]="formGroup"
                  />
                <div class="d-flex align-items-center justify-content-end">
                  <i
                    class="btn btn-sm p-2 d-flex align-items-center justify-content-center"
                    (click)="applyFormat('bold')"
                    [title]="'chatbot.home.bold' | translate"
                    >
                    <i class="ri-bold"></i>
                  </i>
                  <i
                    class="btn btn-sm p-2 d-flex align-items-center justify-content-center"
                    (click)="applyFormat('italic')"
                    [title]="'chatbot.home.italic' | translate"
                    >
                    <i class="ri-italic"></i>
                  </i>
                  <i
                    class="btn btn-sm p-2 d-flex align-items-center justify-content-center"
                    (click)="applyFormat('underline')"
                    [title]="'chatbot.home.underline' | translate"
                    >
                    <i class="ri-underline"></i>
                  </i>
                  <i
                    class="btn btn-sm p-2 d-flex align-items-center justify-content-center"
                    (click)="toogleContainerEmoji()"
                    [title]="'chatbot.home.emojis' | translate"
                    >
                    <i class="ri-emotion-happy-line"></i>
                  </i>

                  <div class="dropdown">
                    <button
                      class="btn btn-sm p-2 d-flex align-items-center justify-content-center"
                      type="button"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                      [title]="'chatbot.home.variables' | translate"
                      >
                      <i class="ri-code-line"></i>
                    </button>
                    <ul class="dropdown-menu">
                      @for (variable of templateVariableList; track
                        variable.value) {
                        <li>
                          <a
                            class="dropdown-item"
                            href="#"
                        (click)="
                          setVariableInContent(variable.value);
                          $event.preventDefault()
                        "
                            >
                            <i class="ri-{{ variable.icon }} me-2"></i>
                            {{ variable.label }}
                          </a>
                        </li>
                      }
                    </ul>
                  </div>

                  <div class="position-relative">
                    @if (showContainerEmoji) {
                      <div class="position-absolute end-0 bottom-100 z-3">
                        <emoji-mart
                          (emojiSelect)="addEmoji($event)"
                          [i18n]="translator"
                          [darkMode]="false"
                        ></emoji-mart>
                      </div>
                    }
                  </div>
                </div>
              </div>

              <mat-menu #menuVar="matMenu">
                @for (variable of templateVariableListWithNameAttendant; track
                  variable) {
                  <button
                    mat-menu-item
                    (click)="setVariableInContent(variable.value)"
                    >
                    <mat-icon color="primary">{{ variable.icon }}</mat-icon>
                    {{ variable.label }}
                  </button>
                }
              </mat-menu>

              <field-error-component
                [field]="'message'"
                [label]="'chatbot.home.messageLabel' | translate"
                [formGroup]="formGroup"
                />
            </div>
          </div>

          <div class="col-md-4">
            <h5 class="mb-1">{{ 'chatbot.home.firstImageToSend' | translate }}</h5>
            <div class="upload-area">
              @if (loadingSpinner$ | async) {
                <div
                  class="w-100 h-100 d-flex justify-content-center align-items-center"
                  >
                  <loading-component></loading-component>
                </div>
              } @else { @if (!attachmentChatbot() || attachmentChatbot() ===
                utilHelper.no_image_upload) {
                <div class="placeholder-content" (click)="addImage()">
                  <i
                    class="mdi mdi-cloud-upload-outline upload-icon text-primary"
                  ></i>
                  <p class="text-primary">{{ 'chatbot.home.clickToUpload' | translate }}</p>
                  <p class="text-muted small">{{ 'chatbot.home.uploadHint' | translate }}</p>
                </div>
                } }

                <div
                  class="upload-area__image"
              [ngStyle]="
                (loadingSpinner$ | async) ? { filter: 'blur(5px)' } : {}
              "
                  >
                  @if (attachmentChatbot() && attachmentChatbot() !==
                    utilHelper.no_image_upload) {
                    <img
                      [src]="attachmentChatbot()"
                      [alt]="'chatbot.home.chatbotImageAlt' | translate"
                      class="preview-img"
                      (click)="$event.stopPropagation()"
                      (error)="onImageLoadError()"
                      />
                    <button
                      class="btn btn-outline-danger mt-2"
                      type="button"
                      (click)="removeAttachment(); $event.stopPropagation()"
                      >
                      <i class="mdi mdi-trash-can-outline me-1"></i> {{ 'chatbot.home.remove' | translate }}
                    </button>
                  }
                </div>

                <input
                  #fileInputFile
                  type="file"
                  accept="image/jpeg, image/png, image/jpg, application/pdf, audio/*"
                  (change)="onMidiaChange($event)"
                  hidden
                  />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="card mt-4">
        <div class="card-body">
          <div>
            <h4 class="mb-2">{{ 'chatbot.home.chatbotMenu' | translate }}</h4>
            <h6 class="text-muted">
              {{ 'chatbot.home.chatbotMenuDescription' | translate }}
            </h6>
          </div>

          <div class="row">
            <div class="col-md-4">
              <div class="d-flex gap-3">
                <div class="d-flex flex-column w-100">
                  <div
                    class="title-menu d-flex align-items-center justify-content-center mt-0"
                    >
                    @if(isAdmin()) {
                      <button (click)="addMenu()" class="btn btn-custom-transparent">
                        <i class="ri-add-line me-1"></i> {{ 'chatbot.home.addToMainMenu' | translate }}
                      </button>
                    }
                  </div>

                  <div class="border rounded shadow">
                    <div class="menu w-100 items-mat">
                      <div class="menu-list p-3 custom-scroll-bar">
                        @if (chatbot.menus?.length > 0) {
                          <ul
                            class="position-relative list-unstyled custom-scroll-bar"
                            >
                            @for (menu of chatbot.menus; track menu; let index =
                              $index) {
                              <li class="mb-3">
                                <div class="position-relative">
                                  <div class="position-relative d-flex">
                                    <div
                                      (click)="selectChatbotMenuOption(menu)"
                                      class="d-flex justify-content-between align-items-center py-1 rounded text-white cursor-pointer shadow-sm menu-item-button"
                              [ngClass]="{
                                'bg-primary':
                                  menu.actived && chatbotMenuIndex !== index,
                                'bg-secondary':
                                  !menu.actived && chatbotMenuIndex !== index,
                                'bg-info':
                                  chatbotMenuIndex === index && menu.actived,
                                'bg-light text-dark':
                                  chatbotMenuIndex === index && !menu.actived,
                                'menu-path-highlighted': isInSelectedPath(
                                  menu.option
                                )
                              }"
                                      >
                                      <span
                                        class="d-flex align-items-center text-nowrap"
                                        >
                                        <span class="fw-semibold fs-6 me-1">
                                          {{ getDisplayOption(menu.option) }}
                                        </span>
                                        <span class="fs-6">{{ menu.title }}</span>
                                      </span>
                                    </div>
                                  </div>

                                  @if (menu.menus?.length > 0) {
                                    <div
                                      class="position-absolute border-start border-primary border-3 vertical-connector"
                                    ></div>
                                    <div
                                      class="position-relative mt-1 ms-4 menu-child-container"
                                      >
                                      <ng-container
                                        class="cursor-pointer"
                              *ngTemplateOutlet="
                                menuRecursivo;
                                context: {
                                  $implicit: menu.menus,
                                  parentIndex: index,
                                  parentOption: menu.option,
                                  level: 1
                                }
                              "
                                      >
                                    </ng-container>
                                  </div>
                                }
                              </div>
                            </li>
                          }
                        </ul>
                      } @else {
                        <h6 class="text-muted fw-light fs-6 text-center py-3">
                          {{ 'chatbot.home.noMenuYet' | translate }}
                        </h6>
                      }
                    </div>
                  </div>
                </div>

                <ng-template
                  #menuRecursivo
                  let-children
                  let-parentIndex="parentIndex"
                  let-parentOption="parentOption"
                  let-level="level"
                  >
                  <ul class="position-relative list-unstyled">
                    @for (child of children; track child; let currentIndex =
                      $index; let last = $last) {
                      <li class="position-relative mb-2">
                        <div
                          class="position-absolute border-bottom border-primary border-2 horizontal-connector"
                        ></div>

                        <div class="position-relative">
                          <div
                            (click)="selectChatbotMenuOption(child)"
                            class="d-flex justify-content-between align-items-center rounded cursor-pointer shadow-sm px-2 py-1 menu-item-button submenu-item"
                        [ngClass]="{
                          'bg-primary': child.actived,
                          'bg-secondary': !child.actived,
                          'menu-path-highlighted': isInSelectedPath(
                            child.option
                          )
                        }"
                            >
                            <span
                              class="d-flex align-items-center text-nowrap text-white"
                              >
                              <span class="fw-medium fs-6 me-1">
                                {{ child.option.split(".").pop() }}
                              </span>
                              <span class="fs-6">{{ child.title }}</span>
                            </span>
                          </div>

                          @if (child.menus?.length > 0) {
                            <div
                              class="position-absolute border-start border-primary border-3 vertical-connector"
                            ></div>
                            <div
                              class="position-relative mt-1 ms-4 menu-child-container cursor-pointer"
                              >
                              <ng-container
                                class="cursor-pointer"
                          *ngTemplateOutlet="
                            menuRecursivo;
                            context: {
                              $implicit: child.menus,
                              parentIndex: currentIndex,
                              parentOption: child.option,
                              level: level + 1
                            }
                          "
                              >
                            </ng-container>
                          </div>
                        }
                      </div>
                    </li>
                  }
                </ul>
              </ng-template>
            </div>
          </div>
        </div>

        <div class="col-md-8">
          <!-- Form the Menu -->
          <div class="w-100">
            <ng-container formArrayName="menus">
              @if (chatbotMenu && selectedFormGroup) {
                <div
                  class="h-100 w-100 rounded border mb-3"
                  [formGroup]="selectedFormGroup"
                  >
                  <div
                    class="bg-light d-flex justify-content-between align-items-center px-3 rounded-top py-2"
                    >
                    <div class="d-flex gap-2">
                      <h5 class="fw-medium text-dark mb-0">
                        {{ chatbotMenu.option }}
                      </h5>
                      <h5 class="mb-0">{{ chatbotMenu.title }}</h5>
                    </div>

                    <div class="d-flex gap-2">
                      @if (isOptionWithDot(chatbotMenu.option)) {
                        <button
                      (click)="
                        $event.stopPropagation();
                        addChildMenu(
                          getParentIndex(chatbotMenu.option),
                          chatbotMenu.option
                        )
                      "
                          class="btn btn-primary d-flex align-items-center justify-content-center p-1 btn-icon"
                          >
                          <i class="ri-add-line"></i>
                        </button>

                        <button
                      (click)="
                        $event.stopPropagation();
                        removeChildMenu(
                          getParentIndex(chatbotMenu.option),
                          getCurrentIndex(chatbotMenu.option),
                          chatbotMenu.option
                        )
                      "
                          class="btn btn-danger d-flex align-items-center justify-content-center p-1 btn-icon"
                          >
                          <i class="ri-delete-bin-line"></i>
                        </button>
                        } @if (isOptionWithoutDot(chatbotMenu.option)) {
                        <button
                          (click)="addChildMenu(chatbotMenuIndex)"
                          class="btn btn-primary d-flex align-items-center justify-content-center p-1 btn-icon"
                          >
                          <i class="ri-add-line"></i>
                        </button>

                        <button
                          (click)="removeMenu(chatbotMenuIndex)"
                          class="btn btn-danger d-flex align-items-center justify-content-center p-1 btn-icon"
                          >
                          <i class="ri-delete-bin-line"></i>
                        </button>
                      }

                      <button
                        (click)="activedChatBotMenu(chatbotMenu.option)"
                        class="btn d-flex align-items-center justify-content-center p-1 btn-icon"
                      [ngClass]="{
                        'btn-primary': getMenuActivedValue(chatbotMenu.option),
                        'btn-secondary': !getMenuActivedValue(
                          chatbotMenu.option
                        )
                      }"
                        >
                        @if (getMenuActivedValue(chatbotMenu.option)) {
                          <i class="ri-eye-line"></i>
                        } @else {
                          <i class="ri-eye-off-line"></i>
                        }
                      </button>
                    </div>
                  </div>

                  <div class="p-3 w-100 h-100">
                    <div class="row gx-4">
                      <div class="col-md-7">
                        <div class="mb-3">
                          <label>{{ 'chatbot.home.title' | translate }}</label>
                          <input
                            type="text"
                            formControlName="title"
                            class="form-control"
                            />
                        </div>
                        <div class="mb-3">
                          <label>{{ 'chatbot.home.message' | translate }}</label>
                          <textarea
                            formControlName="message"
                            class="form-control no-resize min-h-100"
                          ></textarea>
                        </div>

                        @if (shouldDisplayParent(chatbotMenu)) {
                          <div class="w-100">
                            <div class="mb-3">
                              <label>{{ 'chatbot.home.department' | translate }}</label>
                              <mat-select
                                class="form-control"
                                formControlName="department"
                            (selectionChange)="
                              onDepartmentChange($event.value, chatbotMenuIndex)
                            "
                                [placeholder]="'chatbot.home.select' | translate"
                                >
                                <div class="p-2 mb-2 w-100">
                                  <input
                                    class="form-control"
                                    type="text"
                                    (focus)="onFocusDepartment()"
                                [formControl]="
                                  getFilterControl(
                                    chatbotMenuIndex,
                                    'department'
                                  )
                                "
                                (input)="
                                  fetchFilter(
                                    getFilterControl(
                                      chatbotMenuIndex,
                                      'department'
                                    ).value,
                                    chatbotMenuIndex,
                                    'department'
                                  )
                                "
                                    [placeholder]="'chatbot.home.searchDepartmentPlaceholder' | translate"
                                    />
                                </div>
                                <mat-option [value]="null">{{ 'chatbot.home.none' | translate }}</mat-option>
                                @for (item of allDepartments; track item) {
                                  <mat-option [value]="item._id">{{
                                    item.name
                                  }}</mat-option>
                                }
                              </mat-select>
                            </div>
                            <div class="row">
                              <div class="col-md-12 mb-3">
                                <label>{{ 'chatbot.home.agent' | translate }}</label>
                                <mat-select
                                  class="form-control"
                                  formControlName="user"
                                  [placeholder]="'chatbot.home.select' | translate"
                                  [disabled]="!menus.get('department')?.value"
                                  >
                                  <div class="p-2 mb-2 w-100">
                                    <input
                                      class="form-control"
                                      type="text"
                                      (focus)="onFocusUser()"
                                  [formControl]="
                                    getFilterControl(chatbotMenuIndex, 'user')
                                  "
                                  (input)="
                                    fetchFilter(
                                      getFilterControl(chatbotMenuIndex, 'user')
                                        .value,
                                      chatbotMenuIndex,
                                      'user'
                                    )
                                  "
                                      [placeholder]="'chatbot.home.searchAgentPlaceholder' | translate"
                                      />
                                  </div>
                                  @if (departments) {
                                    <mat-option [value]="null">{{ 'chatbot.home.none' | translate }}</mat-option>
                                  }
                                  @for (item of usersByMenu[generateMenuKey(chatbotMenuIndex)] || []; track item) {
                                    <mat-option [value]="item._id">{{
                                      item.name
                                    }}</mat-option>
                                  }
                                </mat-select>
                              </div>

                            </div>
                          </div>

                          <div class="w-100">
                            <div class="mb-3">
                              <label>{{ 'chatbot.home.tags' | translate }}</label>
                              <mat-select
                                class="form-control"
                                formControlName="tags"
                                multiple
                                [placeholder]="'chatbot.home.select' | translate"
                                >
                                <div class="p-2 mb-2 w-100">
                                  <input
                                    class="form-control"
                                    type="text"
                                    (focus)="onFocusTags()"
                                [formControl]="
                                  getFilterControl(chatbotMenuIndex, 'tags')
                                "
                                (input)="
                                  fetchFilter(
                                    getFilterControl(chatbotMenuIndex, 'tags')
                                      .value,
                                    chatbotMenuIndex,
                                    'tags'
                                  )
                                "
                                    [placeholder]="'chatbot.home.searchTagPlaceholder' | translate"
                                    />
                                </div>
                                @for (item of allTags; track item) {
                                  <mat-option [value]="item._id">{{
                                    item.title
                                  }}</mat-option>
                                }
                              </mat-select>
                            </div>
                          </div>
                          @if (webhooks?.length) {
                            <div class="mb-3">
                              <label>{{ 'chatbot.home.webhook' | translate }}</label>
                              <mat-select
                                class="form-control"
                                formControlName="webhook"
                                [placeholder]="'chatbot.home.select' | translate"
                                >
                                <mat-option [value]="null">{{ 'chatbot.home.none' | translate }}</mat-option>
                                @for (webhook of webhooks; track webhook) {
                                  <mat-option [value]="webhook._id">{{
                                    webhook.name
                                  }}</mat-option>
                                }
                              </mat-select>
                            </div>
                          }
                          @if (settingsModule?.activeIAModule) {
                            <div class="col-md-12 mb-3">
                              <label>{{ 'chatbot.home.aiAssistants' | translate }}</label>
                              <mat-select
                                class="form-control"
                                formControlName="assistant"
                                [placeholder]="'chatbot.home.select' | translate"
                            (selectionChange)="
                              onSelectAssistant($event)
                            "
                                >
                                <mat-option [value]="null">{{ 'chatbot.home.none' | translate }}</mat-option>

                                <!-- OpenAI Assistants -->
                                @if (openaiIntegration) {
                                  <mat-optgroup [label]="openaiIntegration.name">
                                    @for (assistant of filteredAssistants; track assistant) {
                                      <mat-option
                                        [value]="assistant.id"
                                        >
                                        {{ assistant.name }}
                                      </mat-option>
                                    }
                                  </mat-optgroup>
                                }

                                <!-- GPT Maker Agents -->
                                @if (gptMakerIntegration) {
                                  <mat-optgroup [label]="gptMakerIntegration.name">
                                    @for (agent of filteredAgents; track agent) {
                                      <mat-option
                                        [value]="agent.id"
                                        >
                                        {{ agent.name }}
                                      </mat-option>
                                    }
                                  </mat-optgroup>
                                }
                              </mat-select>
                            </div>
                          }
                        }
                      </div>

                      <div class="col-md-5">
                        <div class="upload-area">
                          @if (loadingSpinnerChatbotMenu$ | async) {
                            <div
                              class="w-100 h-100 d-flex justify-content-center align-items-center loading"
                              >
                              <loading-component></loading-component>
                            </div>
                          } @else { @if (!chatbotMenu.attachment) {
                            <div
                              class="placeholder-content"
                              (click)="fileInputFileChatbotMenu.click()"
                              >
                              <i
                                class="mdi mdi-cloud-upload-outline upload-icon text-primary"
                              ></i>
                              <p class="text-primary">{{ 'chatbot.home.clickToUpload' | translate }}</p>
                              <p class="text-muted small">
                                {{ 'chatbot.home.uploadHint' | translate }}
                              </p>
                            </div>
                            } }

                            <div
                              class="upload-area__image"
                          [ngStyle]="
                            (loadingSpinnerChatbotMenu$ | async)
                              ? { filter: 'blur(5px)' }
                              : {}
                          "
                              >
                              @if (chatbotMenu.attachment) {
                                <img
                                  [src]="attachmentChatbotMenu()"
                                  [alt]="'chatbot.home.menuImageAlt' | translate"
                                  class="preview-img"
                                  (click)="$event.stopPropagation()"
                                  (error)="onImageLoadError()"
                                  />
                                <button
                                  class="btn btn-outline-danger mt-2"
                                  type="button"
                            (click)="
                              removeAttachmentChatbotMenu(chatbotMenuIndex);
                              $event.stopPropagation()
                            "
                                  >
                                  <i class="mdi mdi-trash-can-outline me-1"></i>
                                  {{ 'chatbot.home.remove' | translate }}
                                </button>
                              }
                            </div>

                            <input
                              #fileInputFileChatbotMenu
                              type="file"
                              accept="image/jpeg, image/png, image/jpg, application/pdf, audio/*"
                          (change)="
                            onChangeFileChatbotMenu($event, chatbotMenuIndex)
                          "
                              hidden
                              />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                }
              </ng-container>
            </div>
          </div>
        </div>
      </div>
    </div>

    <hr class="mt-4"/>

    <div class="row mt-4">
      <div class="col-12 gap-2 d-flex justify-content-end pb-4">
        @if (isAdmin()) {
          <button type="submit" class="btn btn-info fw-bold" (click)="save()">
            {{ 'chatbot.home.save' | translate }}
          </button>
        }
      </div>
    </div>
  </form>
}
